import React, { useState, useEffect, useCallback, useReducer } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import usePrevious from 'utils/customHook/usePrevious';
import paramSetterReducer from 'utils/customReducer/paramSetterReducer';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import { nvl } from 'utils/nvl';
import Table from 'utils/table/Table';
import makeDataLevel from './makeDataLevel';
import { columnSetter } from './columns';

import { Styles } from 'utils/table/Table.css.js';

const GasExcelPreview = ({ searchMap }) => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [canNextPage, setCanNextPage] = useState(false);
  const [canPreviousPage, setCanPreviousPage] = useState(false);
  const [paramState, dispatch] = useReducer(paramSetterReducer, {
    pageIndex: 0,
    pageCount: 0,
    pageSize: 15,
    elementCount: 0,
  });
  const [columns, setColumns] = useState(columnSetter(0));
  const { moduleIdx, beginDate, endDate } = searchMap;
  const prevAmount = usePrevious({ moduleIdx, beginDate, endDate });

  const searchTable = useCallback(() => {
    const url = '/api/gas/excel';
    const beginDate = moment(searchMap.beginDate).format('YYYY-MM-DD HH:mm:ss');
    const endDate = moment(searchMap.endDate).format('YYYY-MM-DD HH:mm:ss');

    customAxiosGetFunction(history, url, {
      params: { ...paramState, moduleIdx: searchMap.moduleIdx, beginDate, endDate },
    }).then((response) => {
      if (nvl(response, null) === null) {
        return false;
      }

      dispatch({ type: 'CHANGE_TOTAL', pageCount: response.totalPages, elementCount: response.totalElements });
      setCanNextPage(!response.last);
      setCanPreviousPage(!response.first);

      setData(
        nvl(response.content, []).map((d, index) => {
          return {
            ...makeDataLevel(d, paramState.pageIndex, paramState.pageSize, index),
          };
        })
      );
    });
  }, [paramState, searchMap]);

  useEffect(() => {
    if (prevAmount != searchMap) {
      setColumns(columnSetter(searchMap.moduleScn));
      searchTable();
    }
  }, [paramState.pageIndex, searchMap]);

  return (
    <Styles>
      <Table
        columns={columns}
        data={data}
        pageIndex={paramState.pageIndex}
        pageSize={paramState.pageSize}
        pageCount={paramState.pageCount}
        elementCount={paramState.elementCount}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        setParamDispatch={dispatch}
      />
    </Styles>
  );
};

export default GasExcelPreview;
